import React from "react";
import { NavLink } from "react-router-dom";

class AboutCompany3 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 bg-white">
          <div className="container">
            <div className="section-content ">
              <div className="m-service-containt text-black">
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <div className="service-about-left">
                      <div className="mt-media">
                        <img
                          src={require("./../../images/extfile/cranes-are-lifting-materials-at-a-busy-constructio-2024-10-16-23-07-58-utc.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 col-sm-12">
                    <div className="service-about-right m-b30">
                      <h3 className="m-t0">Electrical & Instrumentation</h3>
                      <p>
                        At KUO ENTERPRISES LLP, we specialize in providing
                        advanced Electrical & Instrumentation (E&I) services to
                        meet the diverse needs of industrial plants, commercial
                        buildings, and the power sector. Our commitment to
                        quality and safety is reflected in our robust solutions,
                        designed to ensure seamless power management, efficient
                        control, and comprehensive protection across various
                        sectors.
                      </p>
                      <h4>
                        Our Electrical & Instrumentation Services Include:-
                      </h4>
                      <p>
                        <b>
                          High Voltage (HV) & Extra High Voltage (EHV) Power
                          Solutions:{" "}
                        </b>
                        Expertise in HV/EHV switchyards and transmission lines
                        to support large-scale energy demands.
                      </p>
                      <p>
                        <b>LV & HV Power Distribution:</b>
                        Comprehensive solutions for low and high voltage
                        distribution systems, including compact substations and
                        distribution networks, tailored to meet energy needs
                        with efficiency.
                      </p>
                      <p>
                        <b>Panels & Cabling Systems:</b>
                        Design and installation of HT and LT panels, along with
                        efficient cabling systems, ensuring safe and reliable
                        power distribution.
                      </p>
                      <p>
                        <b>Protection, Monitoring & Control:</b>
                        State-of-the-art protection and monitoring systems that
                        guarantee safety, coupled with control solutions for
                        stable power distribution.
                      </p>
                      <p>
                        <b>Reactive Power Management: </b>
                        Optimization of power usage and reduction of energy
                        losses through reactive power management, enhancing the
                        efficiency of electrical systems.
                      </p>
                      <p>
                        <b>Lighting Systems:</b> Reliable lighting solutions for
                        industrial and commercial spaces, with specialized
                        lighting systems for outdoor environments and
                        standby/emergency power support.
                      </p>
                      <p>
                        <b>ELV (Extra Low Voltage) Systems:</b>
                        Integration of low-voltage systems, ensuring effective
                        communication and safety in various settings.
                      </p>
                      <p>
                        <b>Lightning & Grounding Protection: </b>
                        Installation of comprehensive lightning and grounding
                        protection systems, prioritizing safety by effectively
                        managing electrical surges and grounding needs.
                      </p>
                      <p>
                        Our E&I solutions are backed by a team of experts who
                        prioritize quality and safety. With each project, KUO
                        ENTERPRISES LLP delivers dependable, efficient, and
                        scalable solutions to ensure seamless operation, enhance
                        energy efficiency, and promote sustainability across
                        industrial and commercial sectors.
                      </p>
                      <div className="call-for-quote-outer">
                        <div className="call-quote">
                          <span>Call For a Quote:</span>
                          <h4> +91 8921197287, 9437630763</h4>
                        </div>
                        <div className="call-estimate bg-dark">
                          <NavLink
                            to={"#"}
                            className="site-button-secondry btn-effect"
                          >
                            Online Estimate Form
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AboutCompany3;
